import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
  Box,
  Paper,
  useTheme,
} from '@mui/material';

const CurrencyTable = ({ title, currencies }) => {
  const theme = useTheme();

  const getPercentageColor = (changePercentage) => {
    if (changePercentage.startsWith('+')) {
      return theme.palette.success.main;
    }
    if (changePercentage.startsWith('-')) {
      return theme.palette.error.main;
    }
    return theme.palette.text.primary;
  };

  return (
    <Box
      mt={2}
      sx={{
        background: theme.palette.background.default,
        color: theme.palette.text.secondary,
        borderRadius: '0.7rem',
        overflowX: 'auto',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          p: theme.spacing(2),
          fontSize: { xs: '1rem', sm: '1.5rem' }, // responsive font size
        }}
      >
        {title}
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ background: theme.palette.background.paper }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '20%' }} />
              <TableCell sx={{ width: '30%', padding: '0 16px' }}>Name</TableCell>
              <TableCell sx={{ width: '25%', padding: '0 16px' }}>Volume</TableCell>
              <TableCell sx={{ width: '25%', padding: '0 16px' }}>24h Change</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currencies.map((currency) => (
              <TableRow key={currency.symbol}>
                <TableCell sx={{ width: '20%', color: theme.palette.text.primary }}>{currency.symbol}</TableCell>
                <TableCell sx={{ width: '30%' }}>{currency.name}</TableCell>
                <TableCell sx={{ width: '25%' }}>{currency.volume}</TableCell>
                <TableCell sx={{ width: '25%', color: getPercentageColor(currency.changePercentage) }}>
                  {currency.changePercentage}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CurrencyTable;
